import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { alex } from "../characters/Alex";
import { ann } from "../characters/Ann";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { pcLady } from "../characters/PCLady";
import { doImageShake, doTransition, doWaitImageByTime, isAnnCorrupted, isAnnGFAndCorrupted, isAnnHate, isMCCheated, isMCCheatedWithVanessa } from "../helpers/helpers";
import { images } from "./images";
import { V8Day2_Events } from "./V8";

export const V8AnnAlexHome = async (): Promise<any> => {
    doWaitImageByTime(images.v1.Room1);
    if (mc.properties.annStatus === "gf") {
        mc.talk("Alright. Now I can explain.", { method: "On Chat" });
        pcLady.talk("Do your best. I'm listening.", { method: "Over Chat" });
        mc.talk("So apparently Alex didn't betray Ann or do anything behind her back.", { method: "On Chat" });
        pcLady.talk("How is kissing her boyfriend on the lips not a betrayal?", { method: "Over Chat" });

    } else {
        pcLady.talk("Are we going to talk about that kiss from Alex?", { method: "Over Chat" });
        mc.talk("Lol I was waiting for you to ask.", { method: "On Chat" });
        pcLady.talk("Here is me asking!", { method: "Over Chat" });
        mc.talk("Alright.", { method: "On Chat" });
        mc.talk("I found about it only later but I guess I can share it with you right now.", { method: "On Chat" });
        pcLady.talk("Go on, I'm reading.", { method: "Over Chat" });
    }
    mc.talk("So the night before... Or was it a couple of nights, I'm not sure.", { method: "On Chat" });
    mc.talk("Anyway, they both met at Alex's place and had a chat...", { method: "Over Chat" });

    return jump(V8AnnAlexHome_2, "V8AnnAlexHome_2");
};
export const V8AnnAlexHome_2 = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8AlexAnnHome_4, null, 2);
    alex.talk(`I'm so glad you're here!`);
    alex.talk(`It's been a while since we did a sexy slumber party!`);

    ImageClass.setImage(images.v1.Room1, { shake: true, duration: 0 });
    pcLady.talk("Are you bullshitting me?!", { method: "Over Chat" });
    mc.talk("What???", { method: "On Chat" });
    mc.talk("I just started explaining!", { method: "On Chat" });
    pcLady.talk("I know I have to take everything you say as the truth...", { method: "Over Chat" });
    pcLady.talk("But... No way they wore that!", { method: "Over Chat" });
    mc.talk("They did in my imagination...", { method: "On Chat" });
    pcLady.talk("...", { method: "Over Chat" });
    pcLady.talk("Fine. I don't think that matters, anyway.", { method: "Over Chat" });
    mc.talk("Well... not to you!", { method: "On Chat" });

    mc.talk("So, as I was saying...", { method: "On Chat" });

    doWaitImageByTime(images.v8.V8AlexAnnHome_4, null, 1);
    if (isAnnHate()) {
        alex.talk(`So! How are things with Chris?`);
    } else {
        alex.talk(`So! How are things with ${mc.name}?`);
    }

    ImageClass.setImage(images.v8.V8AlexAnnHome_6);
    ann.talk(`Hehe, it's going great!`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_5);
    alex.talk(`Did you have sex yet?`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_8);
    ann.talk(`Hehe.`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_7);
    alex.talk(`You slut! I can't believe you haven't called me!`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_10);
    ann.talk(`I tried! You are always busy.`);
    alex.talk(`Yeah... That's true...`);

    ImageClass.setImage(images.v8.V8AlexAnnHome_13);
    alex.talk(`You know, I was sure you weren't gonna have sex before marriage.`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_10);
    ann.talk(`Hehe, me too... But... I don't know. It felt right.`);
    doWaitImageByTime(images.v8.V8AlexAnnHome_12);
    alex.talk(`Did he pressure you into it or something?`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_9);
    if (isAnnHate()) {
        ann.talk(`A bit, but I wanted it as well.`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_9);
        ann.talk(`It was nice regardless.`);
    } else {
        ann.talk(`Oh no!`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_11);
        ann.talk(`At least I haven't felt pressured by him.`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_9);
        ann.talk(`He is really special, and it just felt right.`);
    }
    ImageClass.setImage(images.v8.V8AlexAnnHome_14);
    ann.talk(`I don't regret it.`);

    alex.talk(`I'm glad to hear that!`);
    alex.talk(`So... How was it?`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_16);
    ann.talk(`Hehe. Stop it!`);
    alex.talk(`I'm waiting...`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_15);
    ann.talk(`It was... Amazing!`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_17);
    alex.talk(`Haha... I bet!`);
    alex.talk(`Does he have a big cock?`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_16);
    if (ann.properties.isCorrupted) {
        ann.talk(`What do you think?`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_15);
        alex.talk(`That he does.`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_16);
        ann.talk(`Hehe.`);

    } else {

        ann.talk(`Stop it! You are embarrassing me!`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_17);
        alex.talk(`I'll take that as a yes. Haha.`);
    }

    ImageClass.setImage(images.v8.V8AlexAnnHome_9);
    ann.talk(`What about you? You seem to be really popular on Insta lately.`);
    doWaitImageByTime(images.v8.V8AlexAnnHome_18);
    alex.talk(`Yeah! My profile kinda blew up!`);
    doWaitImageByTime(images.v8.V8AlexAnnHome_19);
    ann.talk(`I'm not surprised! Who wouldn't want to follow you with those pictures you post.`);
    alex.talk(`Haha.`);

    doWaitImageByTime(images.v8.V8AlexAnnHome_20);
    ann.talk(`And...?`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_21);
    alex.talk(`And what?`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_20);
    ann.talk(`You asked me about having sex with ${mc.name}... What about you?`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_21);
    alex.talk(`Hmm... I don't have anyone special right now.`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_20);
    ann.talk(`And before?`);

    ImageClass.setImage(images.v8.V8AlexAnnHome_22);
    alex.talk(`Not anything worth talking about...`);
    alex.talk(`I went out on some dates... But guys are jerks...`);
    alex.talk(`I mean, at least those from Insta.`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_23);
    ann.talk(`Oh...`);
    ann.talk(`With those comments they write I can only imagine.`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_22);
    alex.talk(`Exactly.`);

    ImageClass.setImage(images.v8.V8AlexAnnHome_23);
    ann.talk(`So... No one?`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_22);
    alex.talk(`To be honest, I've kinda lost hope.`);

    ImageClass.setImage(images.v8.V8AlexAnnHome_23);
    ann.talk(`No... Don't say that.`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_22);
    alex.talk(`Well. Maybe one day I'll meet someone...`);
    doTransition(images.v8.V8AlexAnnHome_24);
    empty.think(`Some time passed...`);

    ImageClass.setImage(images.v8.V8AlexAnnHome_25);
    ann.talk(`Can I suggest something?`);
    alex.talk(`Of course.`);
    // TODO: render of Ann up close talking (same as 25)
    ann.talk(`Promise not to laugh?`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_26);
    alex.talk(`I might laugh...`);
    ann.talk(`Ok, but hear me out!`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_27);
    alex.talk(`Spill it already! I'm getting curious.`);

    ann.talk(`Ok...`);
    ann.talk(`So you know how you said all the guys you meet are jerks?`);
    alex.talk(`Yes...`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_30);
    ann.talk(`Well...`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_29);
    ann.talk(`${mc.name} isn't...`);
    if (isAnnHate()) {
        ImageClass.setImage(images.v8.V8AlexAnnHome_31);
        alex.talk(`Really? After what he has done to you?`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_30);
        ann.talk(`I can't blame him...`);
        ann.talk(`He just wasn't into me...`);
        ann.talk(`At least he was honest about it and said it straight to my face...`);
        ann.talk(`He could have had sex with me and then dump me, but he didn't.`);
        ann.talk(`So... Maybe you can spend some time with him.`);

    } else {
        ann.talk(`Maybe you can spend some time with him.`);
        ann.talk(`You know? Just to see what a real, nice guy is like.`);
        ann.talk(`It will give you back the hope you seem to have lost in men.`);

    }
    ImageClass.setImage(images.v8.V8AlexAnnHome_31);
    alex.talk(`But I already spent some time with him.`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_32);
    alex.talk(`He helped me get my stuff into this house.`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_30);
    alex.talk(`I already know he is a nice guy.`);

    ImageClass.setImage(images.v8.V8AlexAnnHome_29);
    ann.talk(`Yeah... I'm not talking about that.`);
    ann.talk(`I was talking about something more intimate... Like a date or something.`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_33);
    if (isAnnHate()) {
        alex.talk(`I know you have a soft spot for him in your heart. I can't do it.`);

    } else {
        alex.talk(`What?! Are you going to break up with him?!`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_29);
        ann.talk(`What? No!`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_30);
        ann.talk(`You are my best friend. And you deserve to feel what I'm feeling...`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_34);
        alex.talk(`Have you talked to him about this?`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_30);
        ann.talk(`No. I just came up with it...`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_29);
        ann.talk(`But I'm sure he won't have a problem with it... Hehe.`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_33);
        alex.talk(`I don't know about that... It seems like a crazy idea!`);
    }

    ImageClass.setImage(images.v8.V8AlexAnnHome_28);
    ann.talk(`You don't find him attractive?`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_35);
    alex.talk(`...`);
    if (isAnnHate()) {
        alex.talk(`I do. But I still feel like he is your guy...`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_36);
        alex.talk(`Maybe you'll get together in the future, who knows?`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_37);
        alex.talk(`If I'll go through with this it will ruin your chances... I think...`);

    } else {
        alex.talk(`I do. But he is your boyfriend! He is off-limits to me.`);

    }
    ImageClass.setImage(images.v8.V8AlexAnnHome_28);
    ann.talk(`But I'm giving you my permission. I honestly think it's a good idea.`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_32);
    alex.talk(`There are so many things that can go wrong!`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_31);
    if (isAnnHate()) {
        ann.talk(`Like what?`);
    } else {
        alex.talk(`What happens if I agreed and things went too far?`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_28);
        ann.talk(`It's supposed to feel like a date... I won't give you any conditions or anything...`);
        ann.talk(`You should do what you feel like doing.`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_32);

    }
    alex.talk(`You are insane!`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_30);
    ann.talk(`Why?`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_36);
    alex.talk(`Won't you get jealous?`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_31);
    ann.talk(`I am the one suggesting it... So no.`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_29);
    ann.talk(`As I said... I honestly believe it would help you see there are good guys out there.`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_33);
    if (isAnnHate()) {
        alex.talk(`I can understand where you are coming from.`);
        alex.talk(`It's amazing that after everything that has happened between you two, you still defend him and consider him as a good guy.`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_29);
        ann.talk(`Thank you.`);

    } else {
        alex.talk(`I can understand where you are coming from but it's still crazy.`);
        ImageClass.setImage(images.v8.V8AlexAnnHome_31);

    }
    ann.talk(`Well... Consider it and let me know.`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_33);
    alex.talk(`It's a long shot... But I will.`);
    ImageClass.setImage(images.v8.V8AlexAnnHome_29);
    ann.talk(`Hehe. That's all I ask!`);

    doWaitImageByTime(images.v8.V8AlexAnnHome_42);
    alex.talk(`All this talk about ${mc.name} has gotten me so horny!`);
    doWaitImageByTime(images.v8.V8AlexAnnHome_40);
    alex.talk(`Now I can't stop thinking about his big... Hard... Cock...`);
    doWaitImageByTime(images.v8.V8AlexAnnHome_41);
    alex.talk(`Let's get out of these sexy clothes... And fuck while thinking about him!`);
    ann.talk(`I was waiting for you to say that.`);
    ann.talk(`Come here!`);
    return jump(V8AnnAlexHome_PCLady, "V8AnnAlexHome_PCLady");

};
export const V8AnnAlexHome_PCLady = async (): Promise<any> => {
    doImageShake(images.v1.Room1);
    pcLady.talk("BULLSHITTTT!", { method: "Over Chat" });
    mc.talk("Yeah... Well... That might have happened...", { method: "On Chat" });
    pcLady.talk("Was the rest of the story the truth?!", { method: "Over Chat" });
    mc.talk("Just the last part.", { method: "On Chat" });
    pcLady.talk(`...`, { method: "Over Chat" });
    pcLady.talk("Try again.", { method: "Over Chat" });
    mc.talk("Well... Besides the last part, everything else is the truth! I swear.", { method: "On Chat" });
    pcLady.talk("Well... I guess that explains the kiss.", { method: "Over Chat" });
    if (isAnnHate()) {

    } else {
        pcLady.talk("Well done, you managed to get out of this.", { method: "Over Chat" });
        pcLady.talk("I was honestly shocked you'd both do that to Ann.", { method: "Over Chat" });
        if (isMCCheated()) {
            pcLady.talk("I mean, you did cheat on Ann already, but not with her best friend.", { method: "Over Chat" });
            if (isMCCheatedWithVanessa()) {
                pcLady.talk("Maybe Vanessa considered Ann as her best friend but it's not the other way around.", { method: "Over Chat" });
            } else {

            }

        } else {

        }
    }
    // TODO: do you buy it? She is Insta star after all... yada yada
    mc.talk("Should I keep going?", { method: "On Chat" });
    pcLady.talk("It depends....", { method: "Over Chat" });
    pcLady.talk("Is there anything else you forgot to tell me?", { method: "Over Chat" });
    if (isAnnGFAndCorrupted()) {
        mc.talk("Nope, I think I covered everything up to this point.", { method: "On Chat" });
        pcLady.talk("Alright, so keep going!", { method: "Over Chat" });

    } else {
        mc.talk("Oh yeah! I almost forgot.", { method: "On Chat" });
        mc.talk("Remember the package Vanessa told me to hold on for her?", { method: "On Chat" });
        pcLady.talk("What about it?", { method: "Over Chat" });
        mc.talk("I saw it on my doorstep and put it inside my room.", { method: "On Chat" });
        pcLady.talk("What was inside?", { method: "Over Chat" });
        mc.talk("Why do you think I opened it? I respect Vanessa's privacy!", { method: "On Chat" });
        pcLady.talk("Was it a dildo?", { method: "Over Chat" });
        mc.talk("Close...", { method: "On Chat" });
        pcLady.talk("Tell me!", { method: "Over Chat" });
        mc.talk("Alright...", { method: "On Chat" });
        // TODO: MC ALONE FINDING PACKAGE
        doWaitImageByTime(images.v9.V9MCFindingPackage_0, null, 2);
        mc.think(`That's must be the package Vanessa told me to keep for her.`);
        ImageClass.setImage(images.v9.V9MCFindingPackage_1);
        mc.think(`I wonder what's inside...`);
        ImageClass.setImage(images.v9.V9MCFindingPackage_2);
        mc.think(`Should I...?`);
        mc.think(`Why not? It's Vanessa, she won't get upset.`);
        ImageClass.setImage(images.v9.V9MCFindingPackage_3);
        mc.think(`A vibrator with a remote control...`);
        mc.think(`To be honest, I could have guessed that.`);
        ImageClass.setImage(images.v1.Room1);
        pcLady.talk("Shit I was so close!", { method: "Over Chat" });

        pcLady.talk("Anyway! Now you can keep going!", { method: "Over Chat" });



    }



    return jump(V8Day2_Events, "V8Day2_Events");
};
